import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ITabState } from '../../../../states/tabState.model';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { ConnectBakery2bClientWithCustomer } from '../popups/connectBakery2bClientWithCustomer/connectBakery2bClientWithCustomer.popup';
import { FieldsRow } from '../../../../../../shared/components/form';
import { Stack } from '@mui/material';
import { IconButton } from '../../../../../order/common/iconButton/iconButton.component';
import { bakery2bTabState } from '../bakery2b.state';

export const ControlButtons: FC<IControlButtons> = (props) => {
  const {
    selectedPos,
    bakery2bData,
    connectBakery2bClientWithCustomerPopup,
    bakery2bAccountsOptions,
    currentCustomerId,
  } = props;
  const { t } = useTranslation();
  return (
    <FieldsRow marginBottom={1} alignItems='center' spacing={0}>
      <Stack direction='row' spacing={2}>
        <IconButton
          color='primary'
          size='large'
          title={t('customer.addNewRecord')}
          onClick={() => {
            connectBakery2bClientWithCustomerPopup.stream.emit('open', {
              alreadyCreatredBakery2bAccs:
                bakery2bAccountsOptions?.map((item) => ({
                  email: item.email,
                  name: item.name,
                })) ?? [],
              alreadyAddedBakery2bAccs: bakery2bData?.map((item) => item.email) ?? [],
              customerId: currentCustomerId,
            });
          }}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          color='primary'
          size='large'
          title={t('customer.deleteRecord')}
          disabled={!bakery2bData.length || !selectedPos}
          onClick={() =>
            selectedPos &&
            bakery2bTabState.pub.deleteRecord({
              customerId: currentCustomerId,
              bakery2BClientId: selectedPos.id,
            })
          }
        >
          <RemoveIcon />
        </IconButton>
      </Stack>
    </FieldsRow>
  );
};

interface IControlButtons {
  bakery2bData: ITabState['bakery2bAccounts'];
  selectedPos: ITabState['bakery2bAccounts'][number] | null;
  connectBakery2bClientWithCustomerPopup: ConnectBakery2bClientWithCustomer;
  bakery2bAccountsOptions: ITabState['bakery2bTabOptions']['bakery2bAccounts'];
  currentCustomerId: string;
}
